import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import {route, redirect} from './common/common'
import FormPaper from './common/FormPaper';

const styles = (theme) => {
    return {
        root: {
            width: 450,
            height: 500,
        },
        text: {
            marginTop: 24,
        },
        controlGroup: {
            position: 'absolute',
            width: '100%',
            right: 0,
            bottom: 0,
            margin: 0,
        },
        control: {
            float: 'right',
            marginRight: 0,
            marginLeft: 16,
        }
    };
}

class ContactUs extends Component {
    render = () => {
        const {classes} = this.props;

        return (
            <FormPaper
                className={classes.root}
                heading='Contact Us'
                subHeading='for a demo region'
            >
                <Typography
                    className={classes.text}
                    align='justify'
                    gutterBottom={true}
                >
                    Thank you for expressing interest in our product.
                    <br/>
                    <br/>
                    Contact us for more information and allow us to help you
                    setup a demo region to try our product.
                </Typography>
                <div className={classes.controlGroup}>
                    <Button
                        className={classes.control}
                        id='back'
                        color='secondary'
                        variant='contained'
                        onClick={this._handleContactUs}
                    >
                        Contact Us
                    </Button>
                    <Button
                        className={classes.control}
                        id='back'
                        color='secondary'
                        onClick={this._handleBack}
                    >
                        Back to login
                    </Button>
                </div>
            </FormPaper>
        );
    }

    _handleContactUs = () => {
        redirect('https://www.adatos.com/contact/');
    }

    _handleBack = () => {
        route(this, '/home', '');
    }
}

ContactUs.propTypes = {
    setError: PropTypes.func.isRequired,
}

export default withStyles(styles)(ContactUs);
